

/* tslint:disable */



export enum ComponentLinkType {
    Default = 0,
    MedicationGroup = 1,
    FollowedBy = 2,

}


